import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

import Modal from "react-modal";
import { Bars } from "react-loader-spinner";

import {setSocialHandleOnBackend} from '../../utils/backendUtils'

import CancelIcon from "../../assets/cancel_icon.svg";

const HeaderSpan  = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
`

const InputContainerDiv = styled.div`
  width: 398px;
  height: 44px;
  display:flex;
  border: 1px solid rgba(255, 255, 255, 0.08);
  align-items: center;
`

const StyledInput = styled.input`
  width: 326px;
  height: 19px;
  background: #131313;
  padding: 11px 16px;
  display: flex;
  align-items: center;
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  border: none;
  color: white;
  :placeholder,
  :-webkit-input-placeholder {
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: rgba(255, 255, 255, .4);
  }
`

const ActionButtonDiv = styled.div`
  width: 398px;
  height: 44px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  cursor: pointer;
`

const ActionButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`

function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}


export default function AddSocialModalComponent(props:any){

    let modalWidth = "446px";
    let modalHeight = "270px";
    const error = useRef('');
    
    const [instagramText, setInstagramText] = useState('');
    const [discordText, setDiscordText] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    
    const forceUpdate = useForceUpdate();

    const setError = (val)=>{
	error.current = val;
	forceUpdate()
    }
    

    useEffect(()=>{
        let socialDetails:any = localStorage.getItem('social-information');
        
        console.log('socialDetails', socialDetails);
        if(!socialDetails){
            return;
        }
        socialDetails = JSON.parse(socialDetails);
        console.log('socialDetails', socialDetails)
        if(socialDetails.instagram){
            setInstagramText(socialDetails.instagram);
        }
        if(socialDetails.discord){
            setDiscordText(socialDetails.discord);
        }
    },[props.isOpen])
    
    const handleInstagramText  = (value)=>{
	setInstagramText(value)
    }
    
    const handleDiscordText  = (value)=>{
	setDiscordText(value)
    }

    const handleSubmitClick = async (
        tInstagramText:any, tDiscordText:any)=>{
            setShowLoader(true);
            let resp = await setSocialHandleOnBackend(tInstagramText, tDiscordText);
            if(resp){
                props.moveToSuccess()
                setShowLoader(false);
            }
            setShowLoader(false);
        }
    
    
    return (
        <Modal
	    isOpen={props.isOpen}
	    style={{
		content: {
		    background: "#0F0F0F",
		    width: modalWidth,
		    height: modalHeight,
		    marginLeft: "auto",
		    marginRight: "auto",
		    marginTop: "auto",
		    marginBottom: "auto",
		    border:"none",
	    }}}
	>
            <div style={{
	        display: 'flex',
	        flexDirection: 'column',
	        position: 'relative',
	        alignItems: 'center'}}>
                <img onClick={()=>{props.handleModalCloseEvent()}}
		     src={CancelIcon}
		     style={{
		         position: "absolute", opacity: 0.4,
		         height: 14, width:14,
		         right:10, cursor:"pointer",
		         zIndex:10
		     }}
	        />
                <div>
                    <HeaderSpan>
                        Perk Details
                    </HeaderSpan>
                    <InputContainerDiv style={{marginTop: 24}}>
			<StyledInput
			    placeholder={"Enter your intagram @"}
			    value={instagramText}
			    type="text"
			    onChange={e =>handleInstagramText(e.target.value)}
			/>
		    </InputContainerDiv>
                    <InputContainerDiv style={{marginTop: 12}}>
			<StyledInput
			    placeholder={"Enter your discord ID"}
			    value={discordText}
			    type="text"
			    onChange={e =>handleDiscordText(e.target.value)}
			/>
		    </InputContainerDiv>
                </div>
                <ActionButtonDiv onClick={
                ()=>{handleSubmitClick(instagramText,discordText)}}>
                    {(!showLoader) && (
                        <ActionButtonTextSpan>
                            SUBMIT INFO
                        </ActionButtonTextSpan>
                    )}
                    {(showLoader) && (
                        <Bars
                            heigth="30" width="30"
                            color="grey"
                            ariaLabel="loading-indicator" />
                    )}
                </ActionButtonDiv>
            </div>
        </Modal>
    );
}
